export default __webpack_public_path__ + "static/media/icn-user-search-active.1f01bedf.svg";